import { render } from "./LessonsComponent.vue?vue&type=template&id=fb01d460&scoped=true"
import script from "./LessonsComponent.vue?vue&type=script&lang=js"
export * from "./LessonsComponent.vue?vue&type=script&lang=js"

import "./LessonsComponent.vue?vue&type=style&index=0&id=fb01d460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb01d460"]])

export default __exports__